import { Badge } from '@/components/ui/badge';
import type { ChangeRequestSource } from '@/types/changeRequest';

const LABELS: Record<ChangeRequestSource, string> = {
  portal: 'Portal',
  portal_impersonation: 'Portal, by admin',
  admin: 'Admin',
  geena: 'Geena',
};

/** Who asked for a change: the contact in the portal (or an admin acting as them), an admin, or the person in Geena. */
export function ChangeRequestSourceBadge({
  source,
}: {
  source: ChangeRequestSource;
}) {
  return (
    <Badge
      variant={source === 'geena' ? 'default' : 'outline'}
      className="w-fit"
    >
      {LABELS[source] ?? source}
    </Badge>
  );
}
